import React from 'react';
import '../styles/MedicalPanel.css';
import Aishwarya from '../../assets/Aishwarya.jpg';
import Doctor2 from '../../assets/Doctor-2.png';
// import Intern2 from '../../assets/about-img-2.png';
// import Intern3 from '../../assets/about-img-3.png';

const doctors = [
  {
    title: "Head Physiotherapist",
    name: "Dr. Aishwarya Joshi (PT)",
    degree: "Batchelor of Physiotherapy (BPT), Master of Physiotherapy in Neurology (MPT Neuro)",
    image: Aishwarya,
  },
  {
    title: "Ortho Physiotherapist",
    name: "Dr. Vasundhara lohagave (PT)",
    degree: "Batchelor of Physiotherapy (BPT)",
    image: Doctor2,
  },
  // {
  //   title: "Intern",
  //   name: "Dr. Sushant Shinde",
  //   degree: "MD, Internal Medicine (AIIMS) • EULAR Certification in Rheumatology",
  //   image: Intern2,
  // },
  // {
  //   title: "Intern",
  //   name: "Dr. Jyoti Sangle",
  //   degree: "MD Psychological Medicine",
  //   image: Intern3,
  // },
];

const Team = () => {
  return (
    <div className="team-section">
      <h2>Our Medical Team</h2>
      <p className="team-description">
      Our expert physiotherapy team is composed of highly skilled professionals specializing in musculoskeletal rehabilitation, neurological physiotherapy, sports injury recovery, post-surgical rehab, and chronic pain management. With a patient-centered approach and evidence-based techniques, we ensure that every individual receives personalized, holistic care aimed at restoring mobility, reducing pain, and enhancing overall well-being.
      </p>

      <div className="team-grid">
        {doctors.map((doc, index) => (
          <div className="team-card" key={index}>
            <div className="card-title">{doc.title}</div>
            <img src={doc.image} alt={doc.name} className="doc-image" />
            <div className="doc-info">
              <h4>{doc.name}</h4>
              <p>{doc.degree}</p>
              {/* <a href="https://www.linkedin.com/in/dr-aishwarya-joshi-pt-b06ba930a/">READ MORE</a> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
